import React from 'react';
import { useOAuthCallback } from './useOAuthCallback';
import ProcessingStatus from './components/ProcessingStatus';
import SuccessStatus from './components/SuccessStatus';
import ErrorStatus from './components/ErrorStatus';
import RegisteredNotLinkedStatus from './components/RegisteredNotLinkedStatus';

export default function OAuthCallbackPage() {
  const {
    status,
    errorMessage,
    userEmail,
    handleRetry,
    handleGoToLogin
  } = useOAuthCallback();

  const renderStatus = () => {
    switch (status) {
      case 'processing':
        return <ProcessingStatus />;
      case 'success':
        return <SuccessStatus />;
      case 'registered-not-linked':
        return (
          <RegisteredNotLinkedStatus
            userEmail={userEmail}
            onGoToLogin={handleGoToLogin}
          />
        );
      case 'error':
        return (
          <ErrorStatus
            message={errorMessage}
            onRetry={handleRetry}
          />
        );
      default:
        return <ProcessingStatus />;
    }
  };

  return (
    <div style={{
      padding: '2rem',
      textAlign: 'center',
      maxWidth: '500px',
      margin: '0 auto'
    }}>
      {renderStatus()}
    </div>
  );
}
